export function ErrorDirective(){
    return {
        replace: true,
        template: '<div class="carterrorbox">' +
                  '<img src="/public/images/order-online-v2/warning-sign.png" class="warningpic" />' +
                  '<p class="errortext">{{errorMessage}}</p>' +
                  '</div>',
        link: function(){

        }
    };
}
